exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearSearch[data-v-642a24ec]{position:absolute;right:16px;top:35px;width:10px;height:10px;transform:translate(-50%,-50%);outline:none;border:none;background:transparent}.clearSearch span[data-v-642a24ec]{position:absolute;top:50%;left:0;width:100%;height:1px;background:#585858;pointer-events:none}.clearSearch span[data-v-642a24ec]:first-of-type{transform:rotate(45deg)}.clearSearch span[data-v-642a24ec]:nth-of-type(2){transform:rotate(-45deg)}", ""]);

// exports
